<template>
  <v-dialog v-model="app.showCreateAccountDialog" max-width="600" class="overflow-visible" ref="createAccountDialog">
    <v-card class="overflow-visible sigfloCard" :loading="app.authenticating" :disabled="app.authenticating">
      <v-form ref="createAccountForm" submit-prevent>
        <v-card-text class="pb-8 overflow-visible">
          <v-avatar color="white" class="logoAvatar" width="56" height="56">
            <img src="@/assets/images/sigfloSymbolLogo.svg" alt="Sigflo" />
          </v-avatar>
        </v-card-text>
        <v-card-text class="pt-4">
          <div class="font-weight-light text-h4 text-darken-2 d-flex">
            <v-spacer />
            Create Account
            <v-spacer />
          </div>
          <div class="px-12 mt-12">
            <v-text-field
              autofocus
              label="Email"
              outlined
              v-model="email"
              :rules="validation.email"
              filled
              required
            ></v-text-field>
            <v-text-field
              label="First Name"
              outlined
              v-model="firstName"
              :rules="validation.required"
              filled
              required
            ></v-text-field>
            <v-text-field
              label="Last Name"
              outlined
              v-model="lastName"
              :rules="validation.required"
              filled
              required
            ></v-text-field>
            <v-text-field
              label="Password"
              outlined
              filled
              required
              v-model="password"
              :rules="passwordRule"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-text-field
              label="Confirm Password"
              outlined
              filled
              required
              :rules="[passwordMatchRule]"
              v-model="password2"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-btn dark color="primary" block @click="register" large>Create Account</v-btn>
          </div>
          <div v-show="error" class="mt-4 text-center">
            <v-chip color="red" class="pr-2" dark
              ><v-icon class="mx-2" color="yellow darken-1">mdi-alert</v-icon>{{ error }}</v-chip
            >
          </div>
          <div class="d-flex pt-4">
            <v-spacer />
            <div>
              Already have an account?
              <a href="#" @click="showLoginDialog">Log In</a>
            </div>
            <v-spacer />
          </div>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        email: '',
        password: '',
        password2: '',
        showPassword: false,
        firstName: '',
        lastName: '',
        error: ''
      };
    },
    computed: {
      ...mapState(['app'])
    },
    methods: {
      register() {
        if (this.$refs.createAccountForm.validate()) {
          // eslint-disable-next-line
          gtag('event', 'lp_user_registration', {
            send_to: 'G-RH763T1HP1'
          });
          var payload = {
            email: this.email,
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName
          };
          this.$store
            .dispatch('app/register', payload)
            .then((response) => {
              if (response.status == 'Success') {
                const sigMessageModel = {
                  message: `An email verification has been sent to ${this.email}.  Please click on the email link to enable your account.`,
                  messageTitle: response.message,
                  buttonArray: [
                    {
                      label: 'OK',
                      color: 'primary',
                      icon: 'mdi-check'
                    }
                  ]
                };
                this.$store.commit('app/setShowCreateAccountDialog', false);
                this.showPlainDialog(sigMessageModel);
              } else {
                this.error = response.message;
              }
            })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.message)
                this.error = error.response.data.message;
              else this.error = 'An error occurred while creating your account';
            });
        }
      }
    }
  };
</script>

<style>
  .v-dialog {
    overflow-y: visible !important;
  }
  .logoAvatar {
    position: absolute;
    top: -25px; /* Adjust as needed */
    left: 50%;
    transform: translateX(-50%);
  }
</style>
